import { Injectable } from "@angular/core";
import { SnackBarService } from "../../../../cw-utils/snackbar.service";
import { ApiGateway } from "../../../api-gateway";
import { HttpResponse } from "@angular/common/http";

@Injectable()
export class ReportProvider {
    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService,
    ) {}

    generateReport(parans): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("report/", parans).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
                error(err) {
                    reject(err);
                },
            });
        });
    }

    generateReportByGcp(parans): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("report/gcp", parans).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
                error(err) {
                    reject(err);
                },
            });
        });
    }

    generateReportXlsx(parans): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("report/xls", parans).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPdfGuide(orderId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/order/:orderId", { orderId: orderId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfReportSheetOS(orderId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/os/order/sheet/:orderId", { orderId: orderId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfReportControlSheet(performerId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/controlSheet/:performerId", {
                    performerId: performerId,
                })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfReportControlSheetSchedule(
        performerId,
        dateStart: string,
        dateEnd: string,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    "report/controlSheetSchedule/:performerId/:dateStart/:dateEnd",
                    {
                        performerId: performerId,
                        dateStart: dateStart,
                        dateEnd: dateEnd,
                    },
                )
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getreportControlSheet(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("report/controlSheetSchedule", data).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
            });
        });
    }

    getPdfPatientRecord(patientId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/patient/:patientId", { patientId: patientId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfPersonRecordBySchedule(scheduleId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/schedule/person/:scheduleId", {
                    scheduleId: scheduleId,
                })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfApacReport(orderSusId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/apac/:orderSusId", { orderSusId: orderSusId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfSearchSchedulePatientReport(schedule, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`report/scheduleSearch/${type}`, schedule).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
            });
        });
    }

    getPdfBudget(budgetId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/budget/:budgetId", { budgetId: budgetId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfCapture(attachmentList: any[], patientId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`report/capture/${patientId}`, attachmentList)
                .subscribe({
                    next: (res: any) => resolve(res.body),
                    error: (err) => reject(err),
                });
        });
    }

    getPdfReportOS(orderId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/os/order/:orderId", { orderId: orderId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }


    generateReportProtocolDelivery(orderId:number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/order/protocol-delivery/:orderId", { orderId: orderId })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }   

    getPdfReportFinancial(bondIdList: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("report/receipt/financial/", bondIdList).subscribe({
                next: (res: any) => {
                    resolve(res.body);
                },
            });
        });
    }

    getPdfReceiptOS(orderId: any, type: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/os/receipt/:orderId/:type", {
                    orderId: orderId,
                    type: type,
                })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfReceiptAdvancePayment(budgetId: any, type: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/advance-payment/receipt/:budgetId/:type", {
                    budgetId: budgetId,
                    type: type,
                })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    sendEmailPdfReceiptOS(orderId: any, type: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("report/sendemail/os/receipt/:orderId/:type", {
                    orderId: orderId,
                    type: type,
                })
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                });
        });
    }

    getPdfCheckBilling(billingFilter, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`report/check-billing/${type}`, billingFilter)
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getPdfBonds(bondFilter, type: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`report/bonds/${type}`, bondFilter)
                .subscribe({
                    next: (res: any) => {
                        resolve(res.body);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    checkPermissionsReportCostCenter(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("report/checkPermissionCostCenter").subscribe({
                next: (res: any) => {
                    resolve(res);
                },
                error(error) {
                    reject(error);
                },
            });
        });
    }

    checkPermissionsReportCompany(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("report/checkPermissionCompany").subscribe({
                next: (res: any) => {
                    resolve(res);
                },
                error(error) {
                    reject(error);
                },
            });
        });
    }

    printScheduleConfirm(scheduleId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`report/schedule/confirm/${scheduleId}`).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
}
